<template>
  <div id="IndexRegistration" class="body--wrapper">
    <section class="sub--header diagonal-shadow mg-bottom-diagonal">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="box-desc">
              <div class="title">
                Registration
              </div>
              <div class="description">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos
                nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime
                voluptatem, fugit laboriosam assumenda?
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section--wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="title--top">
              <div class="title">
                FORM REGISTRATION
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="onSubmit">
                <div class="col-md-6">
                  <label for="cname" class="form-label">Company Name</label>
                  <input class="form-control" v-model="cname" type="text" placeholder="Nama Instansi" />
                </div>
                <div class="col-md-6">
                  <label for="address" class="form-label">Address</label>
                  <input class="form-control" v-model="address" type="text" placeholder="Alamat Instansi" />
                </div>
                <div class="col-md-6">
                  <label for="telpnum" class="form-label">Telp. Number</label>
                  <input class="form-control" v-model="telpnum" type="text" placeholder="Nomor Telepon" />
                </div>
                <div class="col-md-6">
                  <label for="cperson" class="form-label">Contact Person</label>
                  <input class="form-control" v-model="cperson" type="text" placeholder="Contact Person" />
                </div>
                <div class="col-md-6">
                  <label for="region" class="form-label">Region</label>
                  <input class="form-control" v-model="region" type="text" placeholder="Region e.g Jawa Tengah" />
                </div>
                <div class="col-md-6">
                  <label for="city" class="form-label">City</label>
                  <input class="form-control" v-model="city" type="text" placeholder="City" />
                </div>
                <div class="col-md-12">
                  <br>
                  <button class="btn  btn-lg btn-danger" type="submit">
                    <i class="fa fa-send"></i>
                    Kirim
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import axios from 'axios'
import Vue from 'vue'

export default {
  name: 'IndexRegistration',
  data () {
    return {
      cname: '', address: '', telpnum: '', cperson: '', region: '', city: ''
    }
  },
  methods: {
    onSubmit () {
      // axios.post(``)
      alert(`Vue version : ${Vue.version}`)
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// IndexRegistration.vue?6497e4a9